/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import OtherRules from '../other-rules';
import ModifyRecord from '../modify-record';
import PriceCalendar from '../price-calendar';

interface PropsType {
	enums?: any;
	details?: any;
	disabled?: any;
}

const CarModelPriceDrawer: React.FC<PropsType> = props => {
	const { details, disabled, enums } = props;
	const [title, setTitle] = useState('');

	// tabs配置项
	const items: TabsProps['items'] = [
		{
			key: '1',
			label: '价格日历',
			children: <PriceCalendar title={title} detail={details} disabled={disabled} enums={enums} />,
		},
		{
			key: '2',
			label: '其他销售规则',
			children: <OtherRules detail={details} title={title} disabled={disabled} enums={enums} />,
		},
		{
			key: '3',
			label: '修改记录',
			children: <ModifyRecord title={title} detail={details} />,
		},
	];

	useEffect(() => {
		if (details) {
			const myDetail: any = details;
			const title = `${myDetail.store_name} - ${myDetail.veh_brand_name} · ${myDetail.veh_series_name} · ${myDetail.veh_model_name}`;
			setTitle(title);
		}
	}, []);

	return <Tabs defaultActiveKey="1" type="card" items={items} />;
};

export default CarModelPriceDrawer;
